(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atiq-magic-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atiq-magic-offer')) {
    customElements.define('atiq-magic-offer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.key = 'atiq-magic-november-2026';
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.unlock(), options);
        this.querySelector('a').addEventListener('click', () => this.dialog.close(), options);
        this.editorSelect = event => { if (event.target.contains(this)) this.show(true); };
        document.addEventListener('shopify:section:select', this.editorSelect, options);
        if (window.Shopify && Shopify.designMode) return;
        this.timer = setTimeout(() => this.show(false), Number(this.dataset.delay) || 2000);
      }
      show(editor) {
        if (!this.isConnected || this.dialog.open) return;
        if (!editor) {
          try { if (sessionStorage.getItem(this.key)) return; } catch (error) {}
          if (window.atiqMagicSeen) return;
          if (document.hidden || document.querySelector('dialog[open],cart-drawer[open],menu-drawer[open],search-drawer[open]') || document.activeElement.matches('input,textarea,select,[contenteditable="true"]')) {
            this.timer = setTimeout(() => this.show(false), 1500);
            return;
          }
        }
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        if (!editor) {
          window.atiqMagicSeen = true;
          try { sessionStorage.setItem(this.key, '1'); } catch (error) {}
        }
      }
      unlock() {
        if (this.locked) document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.unlock();
        if (this.abort) this.abort.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atiq-product-colors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atiq-product-colors')) {
    customElements.define('atiq-product-colors', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.events = new AbortController();
        this.panel = this.querySelector('[data-colors-panel]');
        this.list = this.querySelector('[data-colors-list]');
        this.previous = this.querySelector('[data-colors-previous]');
        this.next = this.querySelector('[data-colors-next]');
        this.retry = this.querySelector('[data-colors-retry]');
        this.ids = new Set([this.dataset.productId]);
        this.visited = new Set();
        const url = new URL(this.dataset.searchUrl, location.origin);
        const title = this.dataset.productTitle.replace(/[\\"]/g, '\\$&');
        url.searchParams.set('q', '"' + title + '"');
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'none');
        url.searchParams.set('options[unavailable_products]', 'last');
        url.searchParams.set('section_id', 'atiq-color-results');
        this.preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (this.preview) url.searchParams.set('preview_theme_id', this.preview);
        this.nextUrl = url.href;
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.retry.addEventListener('click', () => this.load(), options);
        this.list.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
        this.list.addEventListener('keydown', event => {
          if (event.target !== this.list || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.list).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, options);
        this.resize = new ResizeObserver(() => this.updateControls());
        this.resize.observe(this.list);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.load();
            }
          }, { rootMargin: '700px' });
          this.observer.observe(this);
        } else {
          this.load();
        }
      }
      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.initialized = false;
        this.loading = false;
        this.list?.replaceChildren();
      }
      normalize(value) {
        return value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
      }
      async load() {
        if (this.loading || !this.nextUrl) return;
        this.loading = true;
        this.retry.hidden = true;
        this.list.setAttribute('aria-busy', 'true');
        try {
          while (this.nextUrl && this.isConnected) {
            const url = new URL(this.nextUrl, location.origin);
            if (url.origin !== location.origin || this.visited.has(url.href)) throw new Error('Invalid colour page');
            this.request = new AbortController();
            const timer = setTimeout(() => this.request.abort(), 15000);
            let html;
            try {
              const response = await fetch(url.href, { signal: this.request.signal, credentials: 'same-origin', priority: 'low' });
              if (!response.ok) throw new Error('Colour request failed');
              html = await response.text();
            } finally {
              clearTimeout(timer);
            }
            if (!this.isConnected) return;
            const document = new DOMParser().parseFromString(html, 'text/html');
            const results = document.querySelector('[data-atiq-color-results]');
            if (!results) throw new Error('Colour results missing');
            const fragment = window.document.createDocumentFragment();
            for (const card of results.querySelectorAll('[data-color-product-id]')) {
              const id = card.dataset.colorProductId;
              if (this.ids.has(id) || this.normalize(card.dataset.colorProductTitle) !== this.normalize(this.dataset.productTitle)) continue;
              this.ids.add(id);
              const link = card.querySelector('a');
              if (this.preview) {
                const target = new URL(link.getAttribute('href'), location.origin);
                target.searchParams.set('preview_theme_id', this.preview);
                link.href = target.href;
              }
              fragment.append(card);
            }
            this.list.append(fragment);
            this.visited.add(url.href);
            this.nextUrl = null;
            if (results.dataset.nextUrl) {
              const next = new URL(results.dataset.nextUrl, location.origin);
              next.searchParams.set('section_id', 'atiq-color-results');
              if (this.preview) next.searchParams.set('preview_theme_id', this.preview);
              this.nextUrl = next.href;
            }
            const count = this.list.children.length;
            this.panel.hidden = count === 0;
            this.querySelector('[data-colors-count]').textContent = this.dataset.countLabel.replace('__COUNT__', String(count));
            this.updateControls();
          }
        } catch (error) {
          if (this.isConnected) {
            this.panel.hidden = false;
            this.retry.hidden = false;
          }
        } finally {
          this.loading = false;
          this.list.removeAttribute('aria-busy');
        }
      }
      move(direction) {
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const card = this.list.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.list.clientWidth;
        this.list.scrollBy({ left: direction * distance * (rtl ? -1 : 1), behavior: reducedMotion ? 'auto' : 'smooth' });
      }
      updateControls() {
        const overflow = this.list.scrollWidth > this.list.clientWidth + 3;
        this.querySelector('[data-colors-controls]').hidden = !overflow;
        this.querySelector('[data-colors-hint]').hidden = !overflow;
        const first = this.list.firstElementChild;
        const last = this.list.lastElementChild;
        if (!first || !last) return;
        const area = this.list.getBoundingClientRect();
        const start = first.getBoundingClientRect();
        const end = last.getBoundingClientRect();
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        this.previous.disabled = !overflow || (rtl ? start.right <= area.right + 3 : start.left >= area.left - 3);
        this.next.disabled = !overflow || (rtl ? end.left >= area.left - 3 : end.right <= area.right + 3);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
